import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getEconomicActivitiesRequest,
  getCitiesRequest,
  getDistrictsRequest,
  getDepartmentsRequest,
  getDocumentTypeRequest,
  getTemporalToken,
  submitMHInvalidateTransactionRequest,
  submitMHTransactionRequest,
  getMeasurementUnitRequest,
  getSaleTypeRequest,
  getPaymentMethodRequest,
  getTermRequest,
  getOperationConditionRequest,
  getMHTransactionsRequest,
  getProductTypesRequest,
  getDocumentsRequest,
  getDocumentProductsRequest,
  getDocumentProductsJsonRequest,
  getCountriesRequest,
  getOfferTypesRequest,
  submitMHContingencyRequest,
  getTaxpayerTypeRequest,
  getPersonTypeRequest,
} from '../../../../billing-api'
import { users } from '../db/users'

const userName = JSON.parse(localStorage.getItem('userBilligData'))
const userLogin = { companyId: userName?.username }
const user = users.find((user) => user.companyId === userLogin.companyId)
const token = await getTemporalToken(user)

export const submitMHTransaction = createAsyncThunk(
  'appInvoice/submitMHTransaction',
  async (data) => {
    //const token = await getTemporalToken(user);
    const userName = await JSON.parse(
      localStorage.getItem('userBilligData')
    )
    const userLogin = { companyId: userName?.username }
    const user = users.find(
      (user) => user.companyId === userLogin?.companyId
    )
    const token = await getTemporalToken(user)
    return await submitMHTransactionRequest(data, token, user.userId)
  }
)

export const submitMHInvalidateDte = createAsyncThunk(
  'appInvoice/submitMHInvalidateDte',
  async (data) => {
    const userName = await JSON.parse(
      localStorage.getItem('userBilligData')
    )
    const userLogin = { companyId: userName?.username }
    const user = users.find(
      (user) => user.companyId === userLogin?.companyId
    )
    const token = await getTemporalToken(user)
    return await submitMHInvalidateTransactionRequest(
      data,
      token,
      user.userId
    )
  }
)

export const submitMHContingencyDte = createAsyncThunk(
  'appInvoice/submitMHContingencyDte',
  async (data) => {
    const userName = await JSON.parse(
      localStorage.getItem('userBilligData')
    )
    const userLogin = { companyId: userName?.username }
    const user = users.find(
      (user) => user.companyId === userLogin?.companyId
    )
    const token = await getTemporalToken(user)
    return await submitMHContingencyRequest(data, token, user.userId)
  }
)

export const getDepartments = createAsyncThunk(
  'appInvoice/getDepartments',
  async () => {
    const userName = await JSON.parse(
      localStorage.getItem('userBilligData')
    )
    const userLogin = { companyId: userName?.username }
    const user = users.find(
      (user) => user.companyId === userLogin?.companyId
    )

    const token = await getTemporalToken(user)

    return await getDepartmentsRequest(token)
  }
)

export const getTaxpayerTypes = createAsyncThunk(
  'appInvoice/getTaxpayerTypes',
  async () => {
    const userName = await JSON.parse(
      localStorage.getItem('userBilligData')
    )
    const userLogin = { companyId: userName?.username }
    const user = users.find(
      (user) => user.companyId === userLogin?.companyId
    )
    const token = await getTemporalToken(user)
    return await getTaxpayerTypeRequest(token)
  }
)

export const getPersonTypes = createAsyncThunk(
  'appInvoice/getPersonTypes',
  async () => {
    const userName = await JSON.parse(
      localStorage.getItem('userBilligData')
    )
    const userLogin = { companyId: userName?.username }
    const user = users.find(
      (user) => user.companyId === userLogin?.companyId
    )
    const token = await getTemporalToken(user)
    return await getPersonTypeRequest(token)
  }
)

export const getCountries = createAsyncThunk(
  'appInvoice/getCountries',
  async () => {
    //const token = await getTemporalToken(user);
    const userName = await JSON.parse(
      localStorage.getItem('userBilligData')
    )
    const userLogin = { companyId: userName?.username }
    const user = users.find(
      (user) => user.companyId === userLogin?.companyId
    )
    const token = await getTemporalToken(user)
    return await getCountriesRequest(token)
  }
)

export const getCities = createAsyncThunk(
  'appInvoice/getCities',
  async (deparmentCode) => {
    //const token = await getTemporalToken(user);
    const userName = await JSON.parse(
      localStorage.getItem('userBilligData')
    )
    const userLogin = { companyId: userName?.username }
    const user = users.find(
      (user) => user.companyId === userLogin?.companyId
    )
    const token = await getTemporalToken(user)
    return await getCitiesRequest(deparmentCode, token)
  }
)

export const getDistricts = createAsyncThunk(
  'appInvoice/getDistricts',
  async ({ departmentCode, municipalityCode }) => {
    const userName = await JSON.parse(
      localStorage.getItem('userBilligData')
    )
    const userLogin = { companyId: userName?.username }
    const user = users.find(
      (user) => user.companyId === userLogin?.companyId
    )
    const token = await getTemporalToken(user)
    return await getDistrictsRequest(departmentCode, municipalityCode, token)
  }
)

export const getOfferTypes = createAsyncThunk(
  'appInvoice/getOfferTypes',
  async () => {
    //const token = await getTemporalToken(user);
    const userName = await JSON.parse(
      localStorage.getItem('userBilligData')
    )
    const userLogin = { companyId: userName?.username }
    const user = users.find(
      (user) => user.companyId === userLogin?.companyId
    )
    const token = await getTemporalToken(user)
    return await getOfferTypesRequest(token)
  }
)

export const getEconomicActivities = createAsyncThunk(
  'appInvoice/getEconomicActivities',
  async () => {
    //const token = await getTemporalToken(user);
    const userName = await JSON.parse(
      localStorage.getItem('userBilligData')
    )
    const userLogin = { companyId: userName?.username }
    const user = users.find(
      (user) => user.companyId === userLogin?.companyId
    )
    const token = await getTemporalToken(user)
    return await getEconomicActivitiesRequest(token)
  }
)

export const getDocumentTypes = createAsyncThunk(
  'appInvoice/getDocumentTypes',
  async () => {
    //const token = await getTemporalToken(user);
    const userName = await JSON.parse(
      localStorage.getItem('userBilligData')
    )
    const userLogin = { companyId: userName?.username }
    const user = users.find(
      (user) => user.companyId === userLogin?.companyId
    )
    const token = await getTemporalToken(user)
    return await getDocumentTypeRequest(token)
  }
)

export const getMeasurementUnit = createAsyncThunk(
  'appInvoice/getMeasurementUnit',
  async () => {
    //const token = await getTemporalToken(user);
    const userName = await JSON.parse(
      localStorage.getItem('userBilligData')
    )
    const userLogin = { companyId: userName?.username }
    const user = users.find(
      (user) => user.companyId === userLogin?.companyId
    )
    const token = await getTemporalToken(user)
    return await getMeasurementUnitRequest(token)
  }
)

export const getProductTypes = createAsyncThunk(
  'appInvoice/getProductTypes',
  async () => {
    //const token = await getTemporalToken(user);
    const userName = await JSON.parse(
      localStorage.getItem('userBilligData')
    )
    const userLogin = { companyId: userName?.username }
    const user = users.find(
      (user) => user.companyId === userLogin?.companyId
    )
    const token = await getTemporalToken(user)
    return await getProductTypesRequest(token)
  }
)

export const getSaleTypes = createAsyncThunk(
  'appInvoice/getSaleTypes',
  async () => {
    //const token = await getTemporalToken(user);
    const userName = await JSON.parse(
      localStorage.getItem('userBilligData')
    )
    const userLogin = { companyId: userName?.username }
    const user = users.find(
      (user) => user.companyId === userLogin?.companyId
    )
    const token = await getTemporalToken(user)
    return await getSaleTypeRequest(token)
  }
)

export const getPaymentMethod = createAsyncThunk(
  'appInvoice/getPaymentMethod',
  async () => {
    //const token = await getTemporalToken(user);

    return await getPaymentMethodRequest(token)
  }
)

export const getTerms = createAsyncThunk(
  'appInvoice/getTerms',
  async () => {
    const userName = await JSON.parse(
      localStorage.getItem('userBilligData')
    )
    const userLogin = { companyId: userName?.username }
    const user = users.find(
      (user) => user.companyId === userLogin?.companyId
    )
    const token = await getTemporalToken(user)
    return await getTermRequest(token)
  }
)

export const getOperationConditions = createAsyncThunk(
  'appInvoice/getOperationConditions',
  async () => {
    const userName = await JSON.parse(
      localStorage.getItem('userBilligData')
    )
    const userLogin = { companyId: userName?.username }
    const user = users.find(
      (user) => user.companyId === userLogin?.companyId
    )
    const token = await getTemporalToken(user)
    return await getOperationConditionRequest(token)
  }
)

export const getMHTransaction = createAsyncThunk(
  'appInvoice/getMHTransaction',
  async (dteId) => {
    //const token = await getTemporalToken(user);
    const userName = await JSON.parse(
      localStorage.getItem('userBilligData')
    )
    const userLogin = { companyId: userName?.username }
    const user = users.find(
      (user) => user.companyId === userLogin?.companyId
    )
    const token = await getTemporalToken(user)

    return await getMHTransactionsRequest(dteId, token)
  }
)

export const getDocuments = createAsyncThunk(
  'appInvoice/getDocuments',
  async ({ documentTypeId, clientDocumentType, documentNumber }) => {
    const userName = await JSON.parse(
      localStorage.getItem('userBilligData')
    )
    const userLogin = { companyId: userName?.username }
    const user = users.find(
      (user) => user.companyId === userLogin?.companyId
    )
    const token = await getTemporalToken(user)
    return await getDocumentsRequest(
      token,
      documentTypeId,
      user.userId,
      clientDocumentType,
      documentNumber
    )
  }
)

export const setProductsCreditList = createAsyncThunk(
  'appInvoice/setProductsCreditList',
  async ({ createdAt, generationCode }, { getState, rejectWithValue }) => {
    try {
      const userName = await JSON.parse(
        localStorage.getItem('userBilligData')
      )
      const userLogin = { companyId: userName?.username }
      const user = users.find(
        (user) => user.companyId === userLogin?.companyId
      )
      const token = await getTemporalToken(user)
      // Catálogos del store: permiten resolver uniMedida y tipoItem del
      // documento original en vez de asumir valores fijos
      const { measurementUnits, saleTypes } = getState().invoiceIssuance
      return await getDocumentProductsRequest(
        token,
        user.userId,
        generationCode,
        createdAt,
        user,
        { measurementUnits, saleTypes }
      )
    } catch (error) {
      console.error('Error in setProductsCreditList thunk: ', error)
      return rejectWithValue(error.message)
    }
  }
)

export const setProductsCreditJsonList = createAsyncThunk(
  'appInvoice/setProductsCreditJsonList',
  async ({ docId }, { getState, rejectWithValue }) => {
    try {
      const userName = await JSON.parse(
        localStorage.getItem('userBilligData')
      )
      const userLogin = { companyId: userName?.username }
      const user = users.find(
        (user) => user.companyId === userLogin?.companyId
      )
      const token = await getTemporalToken(user)
      const { measurementUnits, saleTypes } = getState().invoiceIssuance
      return await getDocumentProductsJsonRequest(token, docId, {
        measurementUnits,
        saleTypes,
      })
    } catch (error) {
      console.error('Error in setProductsCreditJsonList thunk: ', error)
      return rejectWithValue(error.message)
    }
  }
)

export const setRelatedDoc = createAsyncThunk(
  'appInvoice/setRelatedDoc',
  async (relatedDoc) => {
    console.log('relatedDoc: ', relatedDoc)
    return relatedDoc
  }
)
